import type { CatalogItemType } from "building-types/doc/catalogTypes";
import type { CatalogSettingsType } from "./elements/catalog";

export const catalogSettingsTypeToCatalogFieldDescriptors: {
  [settingsType in CatalogSettingsType]: { fieldName: string; catalogItemType: CatalogItemType }[];
} = {
  ["CASEWORK_CATALOG_SETTINGS"]: [{ fieldName: "caseworkTypes", catalogItemType: "CASEWORK_DESCRIPTOR" }],
  ["DOOR_CATALOG_SETTINGS"]: [{ fieldName: "doorTypes", catalogItemType: "DOOR_DESCRIPTOR" }],
  ["WALL_CATALOG_SETTINGS"]: [
    { fieldName: "wallTypes", catalogItemType: "WALL_TYPE" },
    { fieldName: "wallMaterials", catalogItemType: "STRUCTURAL_MATERIAL" },
  ],

  ["STAIR_CATALOG_SETTINGS"]: [{ fieldName: "stairSettingsTable", catalogItemType: "STAIR_SETTING" }],
  ["COLUMN_CATALOG_SETTINGS"]: [{ fieldName: "columnTable", catalogItemType: "COLUMN_DESCRIPTOR" }],
  ["WINDOW_CATALOG_SETTINGS"]: [{ fieldName: "windowTypes", catalogItemType: "WINDOW_DESCRIPTOR" }],
  ["DRAWING_CATALOG_SETTINGS"]: [{ fieldName: "drawings", catalogItemType: "DRAWING" }],
  ["PROFILE_CATALOG_SETTINGS"]: [{ fieldName: "profileTable", catalogItemType: "PROFILE_EXTRUSION_DESCRIPTOR" }],
  ["RAILING_CATALOG_SETTINGS"]: [{ fieldName: "railingSettingsTable", catalogItemType: "RAILING_SETTING" }],
  ["ELECTRICAL_ITEM_CATALOG_SETTINGS"]: [{ fieldName: "loadTypes", catalogItemType: "LOAD_DESCRIPTOR" }],
};
